import React, { useEffect, useState, useContext, useMemo } from "react";
import axios from "axios";
import { IP } from "../../utils/Host";
import { useNavigate } from "react-router-dom";
import style from "./Inspekcja.module.css";
import { AppContext } from "context/AppContext";
import { TechnologyContext } from "context/TechnologyContext";

import { ModalInsertContext } from "context/ModalInsertContext";
import DaneIns from "./components/dane/DaneIns";
import InspekcjaHeader from "./components/header/InspekcjaHeader";
import Row from "./components/row/Row";
import Loading from "components/Loading/Loading";

export default function Inspekcja() {
  const navigate = useNavigate();
  const modalContext = useContext(ModalInsertContext);
  const appContext = useContext(AppContext);
  const techContext = useContext(TechnologyContext);
  const fechOddaniaGrupy = appContext.fechOddaniaGrupy;
  const widokOddan = appContext.widokOddan;

  // --- Twoje nagłówki (zostają bez zmian) ---
  let naglowki_produkty = [`zamowienie_id`,`technologia_id`,`etap`, `format_x`, `format_y`, `global_id`, `id`, `ilosc_stron`, `indeks`, `naklad`, `nazwa`, `oprawa`, `stan`, `status`,  `typ`, `uwagi`]
  let naglowki_elementy = [ `arkusz_szerokosc`, `arkusz_wysokosc`, `etap`, `format_x`, `format_y`, `global_id`, `id`, `ilosc_leg`, `ilosc_stron`, `indeks`, `lega`, `naklad`, `nazwa`, `papier_id`, `papier_info`, `papier_postac_id`, `produkt_id`, `stan`, `status`, `technologia_id`, `typ`, `typ_nazwa`, `uwagi`, `zamowienie_id`]
  let naglowki_fragmenty = [`element_id`, `global_id`, `id`, `ilosc_stron`, `indeks`, `info`, `naklad`, `oprawa_id`, `produkt_id`, `technologia_id`, `typ`, `wersja`, `zamowienie_id`]
  let naglowki_oprawa = [`global_id`,`bok_oprawy`, `data_czystodrukow`, `data_spedycji`,  `id`, `indeks`, `naklad`, `oprawa`, `produkt_id`, `technologia_id`, `utworzono`, `uwagi`, `wersja`, `zamowienie_id`, `zmodyfikowano`]
  let naglowki_procesy_elementow = [`global_id`, `arkusz`, `lega`,`id`,`indeks`,`element_id`,`nazwa`,`back_ilosc`, `back_kolor`,  `front_ilosc`, `front_kolor`,  `ilosc_uzytkow`,  `info`, `infoprocesy`, `komplet`,  `mnoznik`, `naklad`, `narzad`,  `nazwa_elementu`, `nazwa_id`, `nr`, `obszar`, `predkosc`, `proces_id`, `procesor_domyslny`, `produkt`, `produkt_id`, `rodzaj`, `stan`, `status`, `status_nazwa`, `technologia_id`, `typ`, `typ_elementu`, `wykonczenie`, `zamowienie_id`]
  let naglowki_arkusze = [`global_id`, `id`,`indeks`,`arkusz_szerokosc`, `arkusz_wysokosc`, `element_id`,  `ilosc_leg`, `ilosc_stron` , `nadkomplet`, `naklad`, `nr_arkusza`, `papier_id`, `papier_postac_id`, `rodzaj_arkusza`, `technologia_id`, `typ_elementu`, `uwagi`, `zamowienie_id`,`druk_zrealizowano`]
  let naglowki_legi = [`global_id`,`id`,`indeks`,`arkusz_id`, `element_id`,   `ilosc_stron`,  `korekta_zamowienia_alert`, `naklad`, `nr_legi`, `rodzaj_legi`, `technologia_id`, `typ_elementu`, `uwagi`, `zamowienie_id`]
  let naglowki_legiFragmenty = [`arkusz_id`, `element_id`, `fragment_id`, `global_id`, `id`, `indeks`, `korekta_zamowienia_alert`, `lega_id`, `naklad`, `nr_legi`, `oprawa_id`, `technologia_id`, `typ`, `wersja`, `zamowienie_id`]
  let naglowki_grupy = [`arkusz_szerokosc`, `arkusz_wysokosc`, `bulk`, `czas`, `data_spedycji`, `element_id`, `global_id`, `global_proces_id`, `gramatura`, `id`, `ilosc_narzadow`, `indeks`, `klient`, `klient_id`, `koniec`, `korekta_zamowienia_alert`, `mnoznik`, `naklad`, `narzad`, `naswietlenia`, `nazwa`, `nazwa_elementu`, `nazwa_papieru`, `nr`, `nr_stary`, `obszar_procesu`, `papier_info`, `papier_postac`, `papier_postac_id`, `poczatek`, `powleczenie`, `predkosc`, `proces_id`, `proces_nazwa_id`, `procesor_id`, `przeloty`, `rodzaj_procesu`, `rok`, `stan`, `status`, `technologia_id`, `typ_elementu`, `typ_grupy`, `typ_procesu`, `tytul`, `uwagi`, `uwagi_elementu`, `wydanie_papieru_status`, `wykonczenie`, `wykonczenie_procesu`, `zamowienia_pliki_etap`, `zamowienie_id`]
  let naglowki_grupy_oprawa = [`bok_oprawy`, `czas`, `data_spedycji`, `global_id`, `id`, `ilosc_zbieran`, `indeks`, `klient`, `koniec`, `korekta_zamowienia_alert`, `mnoznik`, `naklad`, `narzad`, `nazwa`, `nr`, `obszar_procesu`, `oprawa_id`, `poczatek`, `predkosc`, `proces_id`, `proces_nazwa_id`, `procesor_id`, `rodzaj_procesu`, `rok`, `stan`, `status`, `technologia_id`, `typ_grupy`, `typ_procesu`, `tytul`, `uwagi`, `wersja`, `wykonczenie_procesu`, `zamowienie_id`, `zrealizowano`]
  // let naglowki_wykonania = [`arkusz_id`, `czas`, `do_wykonania`, `element_id`, `global_id`, `grupa_id`, `id`, `ilosc_uzytkow`, `indeks`, `koniec`, `lega_id`, `mnoznik`, `naklad`, `narzad`, `nazwa`, `nazwa_wykonania`, `nr_arkusza`, `papier_id`, `poczatek`, `predkosc`, `proces_id`, `proces_indeks`, `proces_nazwa_id`, `procesor_id`, `przeloty`, `stan`, `status`, `technologia_id`, `typ_elementu`, `uwagi`, `zamowienie_id`]
  let naglowki_wykonania = [`arkusz_id`, `czas`, `do_wykonania`, `element_id`, `global_id`, `grupa_id`, `id`, `ilosc_uzytkow`, `indeks`,  `lega_id`, `mnoznik`, `naklad`,`zrealizowano`,`zrealizowano_nadkomplet`, `brak`, `przeloty`, `stan`, `status`, `narzad`, `nazwa`, `nazwa_wykonania`, `nr_arkusza`, `papier_id`,  `predkosc`, `proces_id`, `proces_indeks`, `proces_nazwa_id`, `procesor_id`, `technologia_id`, `typ_elementu`, `uwagi`, `zamowienie_id`]
  let naglowki_wykonania_oprawa = [`dodal`, `dodal_id`, `global_id`, `grupa_id`, `id`, `naklad`, `oprawa_id`, `proces_id`, `procesor_id`, `technologia_id`, `utworzono`, `zamowienie_id`]
  let naglowki_realizacje = [`global_id`,`utworzono`,`technologia_id`,`zamowienie_id`,`wykonanie_id`,`wykonanie_global_id`,`naklad`,`nazwa`,`grupa_id`,`przeloty_wykonania` ,`proces_id`  ,`zrealizowano`,`procesor_id`,`dodal_id`,`typ`,`uwagi`,`dodal`,`dzial`]
  

  let naglowki_koszty_dodatkowe = [`cena`, `dodal`, `global_id`, `id`, `ilosc`, `indeks`, `info`, `nazwa`, `stan`, `status`, `suma`, `utworzono`, `zamowienie_id`, `zmienil`, `zmodyfikowano`]
  let naglowki_faktury = [`cena`, `dodal`, `global_id`, `id`, `ilosc`, `indeks`, `info`, `nazwa`, `stan`, `status`, `suma`, `utworzono`, `wz`, `zamowienie_id`, `zmienil`, `zmodyfikowano`]
  let naglowki_historia = [`data`, `event`, `id`, `kategoria`, `user`, `user_id`, `zamowienie_id`]
  let naglowki_pliki = [`data_akceptu`, `data_otrzymania_plikow`, `data_utworzenia`, `element_id`, `etap`, `global_id`, `id`, `ilosc_stron`, `nazwa`, `produkt_id`, `stan`, `status`, `technologia_id`, `typ`, `utworzono`, `uwagi`, `zamowienie_id`, `zmodyfikowano`]

  // --- NOWY STAN DLA WIDOCZNOŚCI TABEL ---
  // Wszystkie tabele są domyślnie widoczne (true)
  const [visibleTables, setVisibleTables] = useState({
    produkty: false,
    produktyTech: false,
    elementy: true,
    elementyTech: true,
    fragmenty: false,
    fragmentyTech: false,
    pliki: false,
    procesy: true,
    procesyTech: true,
    arkusze: true,
    legi: true,
    legiFragmenty: true,
    oprawa: false,
    oprawaTech: false,
    grupyWykonan: true,
    wykonania: true,
    realizacje: true,
    grupyOprawa: false,
    wykonaniaOprawa: false,
    koszty: false,
    historia: false,
  });

  // Funkcja przełączająca widoczność
  const handleCheckboxChange = (key) => {
    setVisibleTables(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Definicja wszystkich sekcji, żeby łatwiej nimi zarządzać
const sections = useMemo(() => [
  { key: "produkty", title: "PRODUKTY", data: modalContext.produkty, headers: naglowki_produkty },
  { key: "produktyTech", title: "PRODUKTY TECHNOLOGII", data: techContext.produktyTech, headers: naglowki_produkty },
  { key: "elementy", title: "ELEMENTY", data: modalContext.elementy, headers: naglowki_elementy },
  { key: "elementyTech", title: "ELEMENTY TECHNOLOGII", data: techContext.elementyTech, headers: naglowki_elementy },
  { key: "fragmenty", title: "FRAGMENTY", data: modalContext.fragmenty, headers: naglowki_fragmenty },
  { key: "fragmentyTech", title: "FRAGMENTY TECHNOLOGII", data: techContext.fragmentyTech, headers: naglowki_fragmenty },
  { key: "pliki", title: "PLIKI", data: appContext.zamowieniaPliki, headers: naglowki_pliki },
  { key: "procesy", title: "PROCESY ELEMENTÓW", data: modalContext.procesyElementow, headers: naglowki_procesy_elementow },
  { key: "procesyTech", title: "PROCESY ELEMENTÓW TECHNOLOGII", data: techContext.procesyElementowTech, headers: naglowki_procesy_elementow },
  { key: "arkusze", title: "ARKUSZE", data: techContext.arkusze, headers: naglowki_arkusze },
  { key: "wykonania", title: "WYKONANIA", data: techContext.wykonania, headers: naglowki_wykonania },
  { key: "realizacje", title: "REALIZACJE", data: techContext.realizacje, headers: naglowki_realizacje },
  { key: "legi", title: "LEGI", data: techContext.legi, headers: naglowki_legi },
  { key: "legiFragmenty", title: "LEGI FRAGMENTY", data: techContext.legiFragmenty, headers: naglowki_legiFragmenty },
  { key: "oprawa", title: "OPRAWA", data: modalContext.oprawa, headers: naglowki_oprawa },
  { key: "oprawaTech", title: "OPRAWA TECHNOLOGII", data: techContext.oprawaTech, headers: naglowki_oprawa },
  { key: "grupyWykonan", title: "GRUPY WYKONAN", data: techContext.grupaWykonan, headers: naglowki_grupy },
  { key: "grupyOprawa", title: "GRUPY WYKONAN OPRAWA", data: techContext.grupaOprawaTech, headers: naglowki_grupy_oprawa },
  { key: "wykonaniaOprawa", title: "WYKONANIA OPRAWA", data: techContext.wykonaniaOprawy, headers: naglowki_wykonania_oprawa },
], [
  modalContext.produkty,
  techContext.produktyTech,
  modalContext.elementy,
  techContext.elementyTech,
  modalContext.fragmenty,
  techContext.fragmentyTech,
  appContext.zamowieniaPliki,
  modalContext.procesyElementow,
  techContext.procesyElementowTech,
  techContext.arkusze,
  techContext.legi,
  techContext.legiFragmenty,
  modalContext.oprawa,
  techContext.oprawaTech,
  techContext.grupaWykonan,
  techContext.wykonania,
  techContext.realizacje, // <-- To wymusi odświeżenie gdy wpadną dane z API
  techContext.grupaOprawaTech,
  techContext.wykonaniaOprawy
]);

  // --- Pobieranie danych z API (bez zmian) ---
  async function checkToken() {
    let technologia_id;
    axios.get(IP + "/islogged/" + sessionStorage.getItem("token")).then(async (res) => {
      if (res.data.Status === "Success") {
        try {
          // fechOddaniaGrupy(widokOddan);
          const res = await axios.get(IP + "parametry/" + appContext.idZamowieniaDiag + "/" + sessionStorage.getItem("token"));
          modalContext.setDaneZamowienia([]);
          modalContext.setProdukty([]);
          modalContext.setElementy([]);
          modalContext.setFragmenty([]);
          modalContext.setOprawa([]);
          modalContext.setProcesyElementow([]);
          modalContext.setTechnologieID([]);
          modalContext.setHistoriaZamowienia([]);
          modalContext.setPakowanie([]);
          modalContext.setDaneZamowienia(res.data[0][0]);
          technologia_id = res.data[0][0].technologia_id || 0;
          modalContext.setProdukty(res.data[1]);
          modalContext.setElementy(res.data[2]);
          modalContext.setFragmenty(res.data[3]);
          modalContext.setOprawa(res.data[4]);
          modalContext.setProcesyElementow(res.data[5]);
          modalContext.setTechnologieID(res.data[6]);
          modalContext.setHistoriaZamowienia(res.data[7]);
          modalContext.setPakowanie(res.data[8]);
          modalContext.setKosztyDodatkoweZamowienia(res.data[9]);
          modalContext.setKsiegowosc(res.data[10][0]);
          modalContext.setFaktury(res.data[11]);
          techContext.setDaneTech([]);
          techContext.setProduktyTech([]);
          techContext.setElementyTech([]);
          techContext.setFragmentyTech([]);
          techContext.setOprawaTech([]);
          techContext.setProcesyElementowTech([]);
          techContext.setLegi([]);
          techContext.setLegiFragmenty([]);
          techContext.setArkusze([]);
          techContext.setGrupaWykonan([]);
          techContext.setGrupaWykonanInit([]);
          techContext.setWykonania([]);
            techContext.setRealizacje([]);
console.log("Technologia:"+technologia_id)

          if (technologia_id) {
            const res = await axios.get(IP + "technologie_parametry/" + technologia_id + "/" + sessionStorage.getItem("token"));
            techContext.setDaneTech(res.data[0][0]);
            techContext.setProduktyTech(res.data[1]);
            techContext.setElementyTech(res.data[2]);
            techContext.setFragmentyTech(res.data[3]);
            techContext.setOprawaTech(res.data[4]);
            techContext.setProcesyElementowTech(res.data[5]);
            techContext.setLegi(res.data[6]);
            techContext.setLegiFragmenty(res.data[7]);
            techContext.setArkusze(res.data[8]);
            techContext.setGrupaWykonan(res.data[9]);
            techContext.setWykonania(res.data[10]);
            techContext.setGrupaOprawaTech(res.data[11]);
            techContext.setRealizacje(res.data[13]);
            console.log(res.data)

          }
        } catch {
        } finally {
          appContext.setIsLoading(false);
        }
      } else {
        navigate("/Login");
        appContext.setIsLoading(false);
      }
    });
  }

  useEffect(() => {
    appContext.setIsLoading(true);
    checkToken();
  }, [appContext.idZamowieniaDiag]);

  return (
    <div className={style.main}>
      <InspekcjaHeader onRefresh={checkToken}/>
      

      <div className={style.container}>
        <DaneIns />

        {/* --- PANEL Z CHECKBOXAMI --- */}
        <div className={style.filterPanel}>
          <h3>Filtruj widok tabel:</h3>
          <div className={style.checkboxGrid}>
            {sections.map(sec => (
              <label key={sec.key} className={style.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={visibleTables[sec.key]}
                  onChange={() => handleCheckboxChange(sec.key)}
                />
                {sec.title}
              </label>
            ))}
            <label className={style.checkboxLabel}>
              <input type="checkbox" checked={visibleTables.koszty} onChange={() => handleCheckboxChange("koszty")} />
              KOSZTY I FAKTURY
            </label>
            <label className={style.checkboxLabel}>
              <input type="checkbox" checked={visibleTables.historia} onChange={() => handleCheckboxChange("historia")} />
              HISTORIA
            </label>
          </div>
        </div>

        {/* --- DYNAMICZNE RENDEROWANIE GŁÓWNYCH TABEL --- */}
        {sections.map(sec => visibleTables[sec.key] && (
          <div className={style.main2} key={sec.key}>
            <div className={style.title_container}>
              <p className={style.title}>{sec.title}</p>
            </div>
            <div className={style.containerDouble}>
              <Row tabela={sec.data} naglowki={sec.headers} />
            </div>
          </div>
        ))}

        {/* --- SPECJALNE PRZYPADKI (PODWÓJNE TABELE W JEDNEJ SEKCJI) --- */}
        {visibleTables.koszty && (
          <div className={style.main2}>
            <div className={style.title_container}>
              <p className={style.title}> KOSZTY DODATKOWE / FAKTURY</p>
            </div>
            <div className={style.containerDouble}>
              <Row tabela={modalContext.kosztyDodatkoweZamowienia} naglowki={naglowki_koszty_dodatkowe} />
              <Row tabela={modalContext.faktury} naglowki={naglowki_faktury} />
            </div>
          </div>
        )}

        {visibleTables.historia && (
          <div className={style.main2}>
            <div className={style.title_container}>
              <p className={style.title}> HISTORIA</p>
            </div>
            <div className={style.containerDouble}>
              <Row tabela={modalContext.historiaZamowienia} naglowki={naglowki_historia} />
            </div>
          </div>
        )}

      </div>
      <Loading />
    </div>
  );
}